module.exports = __webpack_public_path__ + "static/media/forest.a7631132.jpg";